import { trackFbAddToCart } from "@base/utils/fb";
import SmallBanner from "@components/common/SmallBanner";
import Title from "@components/common/Title";
import { CartContext } from "@components/contexts/CartContext";
import Layout from "@components/layouts/Layout";
import Testimonials from "@components/sections/LazyTestimonials";
import addToBasketSfx from "@static/sounds/addProduct.mp3";
import axios from "axios";
import { navigate } from "gatsby";
import firebase from "gatsby-plugin-firebase";
import React, { useContext } from "react";
import { MdAddShoppingCart } from "react-icons/md";
import useSWR from "swr";
import useSound from "use-sound";

const endpoints = { products: "/.netlify/functions/products" };

const ProductTemplate = ({ item: a, children, counter }) => {
    const { addProduct, clearCart } = useContext(CartContext);
    const [play] = useSound(addToBasketSfx, { volume: 0.05 });
    const { data: result } = useSWR(endpoints.products, axios.get);

    const item = result
        ? result?.data?.products?.find((p) => p.id === a.id)
        : null;
    const image = item?.images?.length > 0 ? item.images[0] : null;

    return (
        <>
            {!item ? (
                <>Cargando...</>
            ) : (
                <Layout
                    seo={{
                        title: item.title,
                        description: item.description,
                        image: `https://www.iopos.es/${image}`,
                    }}
                >
                    <SmallBanner
                        title={item.title}
                        subtitle={item.description}
                        // filename={item.banner}
                        filename={"bgs/bgGenericNew"}
                    />

                    <div>{children}</div>

                    {item.stock && item.enabled && !item.special_buy && (
                        <div className="container pb-20 lg:px-0">
                            <Title>Comprar producto</Title>
                            <div>
                                <button
                                    title="Comprar producto"
                                    className={`flex w-full justify-center gap-5 rounded bg-ccyan-dark px-5 py-5 uppercase text-white shadow`}
                                    disabled={!item.stock}
                                    onClick={async () => {
                                        clearCart();
                                        addProduct(item);
                                        play();

                                        await trackFbAddToCart({
                                            currency: "EUR",
                                            value: item.price,
                                        });

                                        firebase
                                            .analytics()
                                            .logEvent("add_to_cart", {
                                                item_id: item.sku,
                                                item_name: item.title,
                                                item_category: item.type,
                                                price: item.price,
                                                currency: "EUR",
                                                quantity: 1,
                                            });

                                        navigate("/cesta");
                                    }}
                                >
                                    <MdAddShoppingCart
                                        className="inline h-6 w-6"
                                        style={{ verticalAlign: "middle" }}
                                    />
                                    Comprar producto
                                </button>
                            </div>
                        </div>
                    )}

                    <Testimonials
                        className={`${counter % 2 === 0 ? "" : "bg-gray-100 bg-opacity-50"}`}
                        uid={item.sku}
                    />
                </Layout>
            )}
        </>
    );
};

export default ProductTemplate;
